import PrivateAccountTypeRoute from './PrivateAccountTypeRoute';
import { profileStore } from 'stores';

export default function PrivateBuyerRoute(props) {
	return PrivateAccountTypeRoute(props, profileStore.isBuyer);
}

